import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {device} from "../assets/styles/media";
import Header from "../components/organisms/Header";
import {useMediaQuery} from "react-responsive";
import Footer from "../components/organisms/Footer";
import {faPaw} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const Wrap = styled.div`
    position: relative;
    width: 100%;
    height: ${(props) => props.height}px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    top: 0;
    overflow: hidden;
    ${device.tablet} {
        min-height: 100%;
    }
`;
const ContentWrap = styled.div`
    width: 100%;
    padding-top: 300px;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 500;
    ${device.mobile} {
        font-size: 1rem;
        padding-top: 150px;
    }
`;
const CustomRadioIcon = styled(FontAwesomeIcon)`
    font-size: 80px;
    display: block;
    margin: 0 auto;
    color: #f6ac19;
    margin-bottom: 30px;
    ${device.mobile} {
        margin-bottom: 15px;
        font-size: 50px;
    }
`;
const ErrorBoundary  = () => {
    const isTablet = useMediaQuery({ maxWidth: 1023 });
    const [height, setHeight] = useState(0);
    useEffect(() => {
        setHeight(window.innerHeight);
    }, [height]);
        return (
            <Wrap height={height}>
                <Header isTablet={isTablet}/>
                <ContentWrap>
                    <CustomRadioIcon icon={faPaw}/>
                     해당 페이지를 찾을 수 없습니다.
                </ContentWrap>
                <Footer/>
            </Wrap>
        );
    }
;
export default ErrorBoundary ;
